import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelect from '../../../internal/MultiSelect'
import { getText } from '../../../internal/TextLabels'

const NewsFormRepresentative = ({
  newsRepresentatives,
  representatives,
  fieldName,
  fieldCaption,
  onChange,
}) => {
  const [selectedReps, setSelectedReps] = useState([...newsRepresentatives])
  const [representativeIds, setRepresentativeIds] = useState([])
  const [representativeNames, setRepresentativeNames] = useState([])
  useEffect(() => {
    const ids = []
    const names = []
    representatives.forEach(({ id, country, name, accountSystemChainId }) => {
      ids.push(id)
      names.push(`${name} (${`${country}:${accountSystemChainId}`})`)
    })
    setRepresentativeIds(ids)
    setRepresentativeNames(names)
  }, [representatives])

  const onSelect = values => {
    const newSelectedReps = values.map(id => {
      const representative =
        selectedReps.find(rep => rep.id === id) ||
        representatives.find(rep => rep.id === id) ||
        {}
      return { id, name: representative.name || '' }
    })
    setSelectedReps(newSelectedReps)
    onChange(newSelectedReps)
  }

  return (
    <MultiSelect
      fieldName={fieldName}
      fieldCaption={fieldCaption}
      values={representativeIds}
      defaultValues={selectedReps.map(rep => rep.id)}
      multiple
      names={representativeNames}
      addText={getText('news.add.recipientSection.addRepresentative')}
      onChange={val => onSelect(val)}
      round
      hideButton
    />
  )
}

NewsFormRepresentative.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  representatives: PropTypes.array.isRequired,
  newsRepresentatives: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default NewsFormRepresentative
